import React, { useState } from 'react';
import { Box, Banner, Button, Flex, Text, theme } from '@xometry/xometry_loft';
import { FullOrganizationInvitationFragment } from '../../schema/generated/schema';
import { InviteModalData } from '../Teams';

type PendingInvitesBannerProps = {
  invites: FullOrganizationInvitationFragment[];
  setContentView: (view: string) => void;
  setInvitationModalData: (invite: InviteModalData) => void;
  isStaff: boolean;
};

const PendingInvitesBanner = (props: PendingInvitesBannerProps) => {
  const { invites, setContentView, setInvitationModalData, isStaff } = props;
  const [showBanner, setShowBanner] = useState(true);
  if (!showBanner) return null;
  const acceptInvite = (invite: FullOrganizationInvitationFragment) => {
    setInvitationModalData({
      ...invite,
      inviterFirstName: invite?.senderUserData?.firstName || '',
      inviterLastName: invite?.senderUserData?.lastName || '',
      teamName: invite.organization.name,
      openStatus: true,
      url: invite.acceptInviteUrl || '',
      buttonDecision: 'Accept',
      userEmail: invite?.userData?.email || '',
      orgId: invite.organization.id,
      isStaffActingOnBehalfOfUser: isStaff,
      userName: '',
    });
  };
  const openPendingView = () => {
    const url = new URL(window.location.href);
    url.searchParams.append('view', 'pending');
    window.history.pushState({ path: url.href }, '', url.href);
    setContentView('pending');
  };
  if (!invites || invites.length === 0) return null;
  const invite = invites[0];
  const senderName = invite?.senderUserData?.email?.endsWith('@xometry.com')
    ? `You're invited`
    : `${invite?.senderUserData?.firstName} invited you`;
  return (
    <Box maxWidth="792px" width="100%" marginTop={theme.space[5]}>
      <Banner kind="primary">
        <Flex justifyContent="space-between" alignItems="center">
          <Flex flexDirection="column">
            <Text fontWeight={600}>
              {invites.length === 1
                ? `${senderName} to join ${invite?.organization?.name}`
                : 'Your team invitations are waiting for you.'}
            </Text>
            <Text fontSize="13px">
              {invites.length === 1
                ? 'Join your team to collaborate on quotes, get updates, and much more.'
                : 'View and accept your invitations to start collaborating on quotes, get team order updates, and much more.'}
            </Text>
          </Flex>
          <Flex gap={theme.space[3]} height="34px">
            <Button onClick={() => setShowBanner(false)}>Dismiss</Button>
            <Button
              kind="primary"
              width="max-content"
              onClick={() =>
                invites.length === 1 ? acceptInvite(invite) : openPendingView()
              }
            >
              {invites.length === 1 ? 'Accept' : 'View Invitations'}
            </Button>
          </Flex>
        </Flex>
      </Banner>
    </Box>
  );
};

export default PendingInvitesBanner;
